import store from '@/store/store';
import edition from '@/api/edition/index';
import { pGetAllPieceJointe } from '@/api/pieceJointes/index';
import { EDITION_BON_LIVRAISON } from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import { PIECE_JOINTE_TYPE_ETIQUETTE_EXPEDITION } from '@/configuration/general/pieceJointeConf';

export async function downloadPj(bonExpedition) {
  const pj = (await pGetAllPieceJointe({ elementsId: [bonExpedition.id] })).data.result.items
    .find(p => p.type.libelle === PIECE_JOINTE_TYPE_ETIQUETTE_EXPEDITION);
  if (!pj) return;
  const link = document.createElement('a');
  link.href = pj.cheminMin || pj.chemin;
  link.download = pj.nom;
  link.click();
}

export async function editionOts(otIds, extension, parametresAdditionnels = {}) {
  const response = await edition({
    ids: otIds,
    extension: extension,
    societe: store.getters['societe/societeActiveId'],
    typeDonnee: EDITION_BON_LIVRAISON,
    parametresAdditionnels: parametresAdditionnels,
  });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(response.data);
  const disposition = response.request.getResponseHeader('Content-Disposition');
  link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
  link.click();
}

export function preValidation(bonExpedition) {
  const validationErrors = [];
  if (!bonExpedition.adresseExpediteur.codePostal) {
    validationErrors.push({
      members: ['bonExpedition.adresseExpediteur.codePostal'],
      message: 'bonExpedition.adresseExpediteur.codePostal field is required.',
    });
  }
  if (!bonExpedition.adresseExpediteur.ville) {
    validationErrors.push({
      members: ['bonExpedition.adresseExpediteur.ville'],
      message: 'bonExpedition.adresseExpediteur.ville field is required.',
    });
  }
  if (!bonExpedition.adresseExpedition.codePostal) {
    validationErrors.push({
      members: ['bonExpedition.adresseExpedition.codePostal'],
      message: 'bonExpedition.adresseExpedition.codePostal field is required.',
    });
  }
  if (!bonExpedition.adresseExpedition.ville) {
    validationErrors.push({
      members: ['bonExpedition.adresseExpedition.ville'],
      message: 'bonExpedition.adresseExpedition.ville field is required.',
    });
  }
  if (!validationErrors.length) return;
  const error = new Error();
  error.response = { data: { error: { validationErrors } } };
  throw error;
}
